import React, { useRef, useLayoutEffect, useState, useContext } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Crossword as ReactCrossword } from '@jaredreisinger/react-crossword';
import styles from './Crossword.module.scss';
import Swal from 'sweetalert2';
import { DataContex } from '../../context/DataContext';

// Datos del crucigrama


// Tema personalizado para el crucigrama
const theme = {
  columnBreakpoint: '768px',
  gridBackground: 'transparent',
  cellBackground: '#ffffff',
  cellBorder: '#333333',
  textColor: '#000000',
  numberColor: '#666666',
  focusBackground: '#5f9ea1',
  highlightBackground: '#b2dfe1',
  correctBackground: '#e8f5e9',
  correctTextColor: '#1b5e20',
  // Estilos específicos para el layout
  crosswordWrapper: {
    maxWidth: '100%',
    margin: '0 auto'
  },
  crosswordGrid: {
    width: '100%',
    height: 'auto',
    maxHeight: '600px'
  },
  crosswordClues: {
    fontSize: '1rem',
    lineHeight: '1.4'
  }
};

export const Crossword = ({ title = 'Crucigrama', description, crucigramaId }) => {
  const { crucigramas } = useContext(DataContex);
  const crucigrama = crucigramas.find(c => c.id === crucigramaId);
  const data = crucigrama?.crosswordData;

  const crosswordRef = useRef();
  const [isComplete, setIsComplete] = useState(false);
  const [correctAnswers, setCorrectAnswers] = useState([]);

  // Función para llenar la palabra 1 (solo si existe data)
  const fillWord1 = () => {
    if (crosswordRef.current && data && data.down && data.down[1]) {
      const word = data.down[1].answer;
      const { row, col } = data.down[1];
      for (let i = 0; i < word.length; i++) {
        crosswordRef.current.setGuess(row + i, col, word[i]);
      }
    }
  };

  // Función para completar automáticamente el crucigrama (solo desarrollo)
  const autoComplete = () => {
    if (crosswordRef.current) {
      crosswordRef.current.fillAllAnswers();
      setIsComplete(true);
    }
  };

  // Función para verificar si el crucigrama está completo
  const checkCompletion = () => {
    if (crosswordRef.current && data) {
      const totalWords = Object.keys(data.across).length + Object.keys(data.down).length;
      const completedWords = correctAnswers.length;
      const isComplete = completedWords >= totalWords - 1;
      setIsComplete(isComplete);
    }
  };

  // Función para revisar respuestas
  const checkAnswers = () => {
    if (crosswordRef.current) {
      if (!isComplete) {
        Swal.fire({
          title: '¡Crucigrama Incompleto!',
          text: 'Debes completar todas las palabras antes de revisar las respuestas.',
          icon: 'warning',
          confirmButtonText: 'Entendido'
        });
        return;
      }
      const isCorrect = crosswordRef.current.isCrosswordCorrect();
      if (isCorrect) {
        Swal.fire({
          title: '¡Felicitaciones!',
          text: '¡Todas las respuestas son correctas!',
          icon: 'success',
          confirmButtonText: '¡Genial!'
        });
      } else {
        Swal.fire({
          title: '¡Ups!',
          text: 'Algunas respuestas no son correctas. Revisa nuevamente.',
          icon: 'error',
          confirmButtonText: 'Entendido'
        });
      }
    }
  };

  // Función que se ejecuta cuando una respuesta es correcta
  const handleCorrect = (direction, number, answer) => {
    setCorrectAnswers(prev => [...prev, { direction, number, answer }]);
  };

  // Función que se ejecuta cuando se carga una respuesta correcta
  const handleLoadedCorrect = (answers) => {
    setCorrectAnswers(answers);
  };

  // Función para limpiar el crucigrama
  const resetCrossword = () => {
    if (crosswordRef.current && data && data.down && data.down[1]) {
      const word1 = data.down[1].answer;
      const { row, col } = data.down[1];
      crosswordRef.current.reset();
      setTimeout(() => {
        for (let i = 0; i < word1.length; i++) {
          crosswordRef.current.setGuess(row + i, col, word1[i]);
        }
      }, 100);
      setCorrectAnswers([]);
      setIsComplete(false);
    }
  };

  // Usar useLayoutEffect para asegurar el render antes de pintar la palabra
  useLayoutEffect(() => {
    const timer = setTimeout(fillWord1, 0);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [crucigramaId, data]);

  if (!crucigramaId) {
    return (
      <Container className={styles.crosswordContainer}>
        <Row className={`${styles.crosswordHeader} mb-5 align-items-center`}>
          <Col xs={12}>
            <h1>¡Elegí un crucigrama!</h1>
            <p>Seleccioná una miniatura para comenzar a jugar.</p>
          </Col>
        </Row>
      </Container>
    );
  }

  if (!data) return null;

  return (
    <Container className={styles.crosswordContainer}>
      <Row className={`${styles.crosswordHeader} mb-5 align-items-center`}>
        <Col xs={12}>
          <h1>{crucigrama?.title || title}</h1>
          {(crucigrama?.description || description) && <p>{crucigrama?.description || description}</p>}
        </Col>
      </Row>
      <div className={styles.crosswordWrapper}>
        <ReactCrossword
          ref={crosswordRef}
          data={data}
          useStorage={false}
          acrossLabel="Horizontales"
          downLabel="Verticales"
          theme={theme}
          onCrosswordChange={checkCompletion}
          onCorrect={handleCorrect}
          onLoadedCorrect={handleLoadedCorrect}
        />
      </div>
      <div className={styles.buttonsContainer}>
        <Button
          variant="primary"
          onClick={checkAnswers}
          className={styles.checkAnswers}
        >
          Revisar Respuestas
        </Button>
        <Button
          variant="outline-danger"
          onClick={resetCrossword}
        >
          Limpiar Crucigrama
        </Button>
        {/* Botón de desarrollo - Eliminar antes de producción */}
        <Button
          variant="outline-secondary"
          onClick={autoComplete}
          className="dev-button"
        >
          Completar Automático (Dev)
        </Button>
      </div>
    </Container>
  );
}; 